<img
  id="shared-image"
  [src]="getImagePath(imgName)"
  [alt]="alt"
  class="image"
  [ngStyle]="getStyles()"
/>
